import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export type CreateApiKeyPayloadType = {
  name: string;
  date_expired: Date;
};

export type CreatedApiKeyType = {
  date_expired: string;
  id: string;
  key: string;
};

export const createApiKeyApi = async (
  payload: CreateApiKeyPayloadType
): Promise<ApiResponseType<CreatedApiKeyType>> => {
  const uri = '/api-key/';

  return authApiService.POST(uri, payload);
};
